import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _styled2 from "styled-components";
import _styled from "styled-components";
var _Eye;
var _excluded = ["className", "style", "css", "data-testid", "data-cy", "isPremium", "disableRedirections", "onGoToLiveDetail", "openLiveDetailInNewTab", "source", "sourceDetail"];
import { Fragment } from "react";
import cn from "classnames";
import { createUrlWithSourceQueryParams } from "@crehana/analytics";
import { Eye, MessageCircle } from "@crehana/icons/outline";
import { Clamp, LazyImage } from "@crehana/ui";
import { transformData } from "@crehana/utils";
import { LiveTargetEnum } from "../../../__generated__/graphql-schema";
import PremiumExclusiveTag from "../../Tags/PremiumExclusiveTag";
import { PAST_LIVE_CARD_CONTAINER_CLASSNAMES, PastLiveCardContainer, PastLiveCardImageWrapper } from "./PastLiveCard.styles";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var PastLiveCard = function PastLiveCard(_ref) {
  var _StyledPremiumExclusi, _Clamp, _Fragment;
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? 'w-full' : _ref$className,
    style = _ref.style,
    css = _ref.css,
    dataTestId = _ref['data-testid'],
    dataCy = _ref['data-cy'],
    isPremium = _ref.isPremium,
    disableRedirections = _ref.disableRedirections,
    onGoToLiveDetail = _ref.onGoToLiveDetail,
    openLiveDetailInNewTab = _ref.openLiveDetailInNewTab,
    source = _ref.source,
    sourceDetail = _ref.sourceDetail,
    live = _objectWithoutProperties(_ref, _excluded);
  var title = live.title,
    coverCard = live.coverCard,
    coverCardPlaceholder = live.coverCardPlaceholder,
    liveDetailUrl = live.liveDetailUrl,
    liveCategory = live.liveCategory,
    presenters = live.presenters,
    views = live.views,
    channelTotalMessage = live.channelTotalMessage,
    targetEnum = live.targetEnum;
  var livePresenter = presenters ? transformData(presenters)[0] : undefined;
  var liveUrlWithSource = liveDetailUrl ? createUrlWithSourceQueryParams({
    url: liveDetailUrl,
    source: source,
    sourceDetail: sourceDetail
  }) : undefined;
  var onGoToLive = function onGoToLive() {
    if (onGoToLiveDetail) {
      onGoToLiveDetail(live);
    }
    if (!disableRedirections && liveUrlWithSource) {
      if (openLiveDetailInNewTab) {
        window.open(liveUrlWithSource);
      } else {
        window.location.href = liveUrlWithSource;
      }
    }
  };
  var renderLiveDetails = function renderLiveDetails() {
    return /*#__PURE__*/_jsxs(Fragment, {
      children: [/*#__PURE__*/_jsxs(PastLiveCardImageWrapper, {
        className: "relative flex-shrink-0 w-full",
        children: [/*#__PURE__*/_jsx(LazyImage, {
          className: "w-full h-full",
          imgClassName: "object-cover",
          imgxParams: {
            w: 320,
            h: 152,
            dpr: 2,
            crop: 'faces'
          },
          src: coverCard || '',
          placeholder: coverCardPlaceholder,
          alt: title,
          isDark: true
        }), targetEnum === LiveTargetEnum.TARGET_PREMIUM && (_StyledPremiumExclusi || (_StyledPremiumExclusi = /*#__PURE__*/_jsx(_StyledPremiumExclusiveTag, {
          className: "absolute",
          isPremium: isPremium
        })))]
      }), /*#__PURE__*/_jsxs("div", {
        className: "flex flex-col justify-between h-full p-16 text-left text-white bg-base-lighter-16",
        children: [/*#__PURE__*/_jsxs("div", {
          className: "flex flex-col items-start",
          children: [(liveCategory === null || liveCategory === void 0 ? void 0 : liveCategory.name) && /*#__PURE__*/_jsx("span", {
            className: "mb-8 font-label text-secondary-light",
            children: liveCategory.name
          }), _Clamp || (_Clamp = /*#__PURE__*/_jsx(Clamp, {
            as: "h5",
            className: "font-subtitle3",
            clamp: 3,
            children: title
          })), livePresenter && /*#__PURE__*/_jsx("span", {
            className: "mt-8 font-body4 text-base-lighter",
            children: livePresenter.displayName || livePresenter.username
          })]
        }), (!!views || !!channelTotalMessage) && /*#__PURE__*/_jsxs("footer", {
          className: "flex items-center mt-16 font-body4",
          children: [!!views && (_Fragment || (_Fragment = /*#__PURE__*/_jsxs(Fragment, {
            children: [_Eye || (_Eye = /*#__PURE__*/_jsx(Eye, {
              size: 24,
              ignoreColor: true,
              className: "mr-8 fill-current"
            })), views]
          }))), !!channelTotalMessage && /*#__PURE__*/_jsxs(Fragment, {
            children: [/*#__PURE__*/_jsx(MessageCircle, {
              size: 24,
              ignoreColor: true,
              className: cn('fill-current mr-8', {
                'ml-24': !!views
              })
            }), channelTotalMessage]
          })]
        })]
      })]
    });
  };
  var renderPastLiveCard = function renderPastLiveCard() {
    var containerClassName = 'block w-full h-full flex flex-col';
    if (!disableRedirections && !onGoToLiveDetail && liveUrlWithSource) {
      return /*#__PURE__*/_jsx(PastLiveCardContainer, {
        as: "a",
        href: liveUrlWithSource,
        target: openLiveDetailInNewTab ? '_blank' : undefined,
        rel: openLiveDetailInNewTab ? 'noopener noreferrer' : undefined,
        className: containerClassName,
        "aria-label": title,
        children: renderLiveDetails()
      });
    }
    if (onGoToLiveDetail) {
      return /*#__PURE__*/_jsx(PastLiveCardContainer, {
        as: "button",
        type: "button",
        onClick: onGoToLive,
        className: containerClassName,
        "aria-label": title,
        children: renderLiveDetails()
      });
    }
    return /*#__PURE__*/_jsx(Fragment, {
      children: renderLiveDetails()
    });
  };
  return /*#__PURE__*/_jsx(_StyledPastLiveCardContainer, {
    className: cn(PAST_LIVE_CARD_CONTAINER_CLASSNAMES, className),
    style: style,
    "data-testid": dataTestId,
    "data-cy": dataCy,
    $_css: css,
    children: renderPastLiveCard()
  });
};
export default PastLiveCard;
var _StyledPremiumExclusiveTag = /*#__PURE__*/_styled(PremiumExclusiveTag).withConfig({
  componentId: "sc-1nw83s6-0"
})(["\n              top: 12px;\n              left: 12px;\n            "]);
var _StyledPastLiveCardContainer = /*#__PURE__*/_styled(PastLiveCardContainer).withConfig({
  componentId: "sc-1nw83s6-1"
})(["", ""], function (p) {
  return p.$_css;
});